<!-- 详情 -->
<template>
  <a-modal
    title="查看"
    width="1000px"
    :visible="visible"
    @cancel="onClose"
    v-if="visible"
    class="notice-see"
  >
    <div class="">
      <div class="notice-see-flex">
        <div class="see-flex-left">
          <div class="left-label">发布人：</div>
          <div class="left-value">{{ ruleForm.publishPerson }}</div>
        </div>
        <a-divider type="vertical" class="m-20" />
        <div class="see-flex-left">
          <div class="left-label">发布时间：</div>
          <div class="left-value">{{ ruleForm.publishTime }}</div>
        </div>
      </div>

      <div class="">
        <div class="see-flex-concent">
          <div class="left-label">通知内容：</div>
          <div class="left-value">
            {{ ruleForm.noticeContent }}
          </div>
        </div>
      </div>

      <div class="">
        <div class="see-flex-concent">
          <div class="left-label">附件：</div>
          <div class="left-value">
            <div
              v-for="(item, index) in fileList"
              :key="index"
              class="file-list-style"
            >
              <div class="left" @click="downFile(item)">
                <a-icon type="paper-clip" class="icon" /><span class="label">{{
                  item.name
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template slot="footer">
      <a-button @click="onClose">取消</a-button>
    </template>
  </a-modal>
</template>

<script>
import API from "@/api/logManage.js";
export default {
  props: {
    // 表格选中数据
    modalData: {
      type: Object,
      required: false,
    },
    modalFlag: Boolean,
  },
  data() {
    return {
      visible: false,
      ruleForm: {},
      fileList: [],
    };
  },
  methods: {
    // 关闭
    onClose() {
      this.$emit("handleFlag", false);
    },
    // 获取详情
    getDetail() {
      let params = {
        data: {
          params: {
            id: this.modalData.id,
          },
        },
      };
      API.getDrugMessageNotice(params, (callback) => {
        if (callback.status == "S" && callback.data) {
          let backData = callback.data;
          this.ruleForm = backData;

          let attachInfoList = [];
          backData.attachInfoList &&
            backData.attachInfoList.map((item) => {
              let obj = {};
              obj.url = item.attachUrl;
              obj.name = item.attachFileName;
              attachInfoList.push(obj);
            });
          this.fileList = attachInfoList || [];
        }
      });
    },
    // 下载
    downFile(file) {
      let params = {
        data: {
          params: {
            downLoadUrl: file.url || "",
          },
        },
      };
      API.downLoadFileByUrl(params, (callback) => {});
    },
  },
  watch: {
    modalFlag(newVal, oldVal) {
      this.visible = newVal;
      if (newVal) {
        this.getDetail();
      }
    },
  },
};
</script>

<style scoped lang="less">
.notice-see {
  .notice-see-flex {
    display: flex;
    align-items: center;

    .m-20 {
      margin: 0 30px;
    }

    .see-flex-left {
      display: flex;
      .left-label {
        color: rgba(9, 21, 45, 0.5);
      }

      .left-value {
        color: #09152d;
      }
    }
  }

  .see-flex-concent {
    padding-top: 20px;
    .left-label {
      color: rgba(9, 21, 45, 0.5);
    }

    .left-value {
      color: #09152d;
      padding-top: 8px;
      display: flex;
      word-break: break-all;
    }
  }

  .file-list-style {
    padding: 0px 8px;
    cursor: pointer;
    border-radius: 2px;

    .left {
      color: #00000073;

      .label {
        padding-left: 2px;
        color: #0553a5;
      }
      .icon {
        color: #0553a5;
      }
    }
  }
}
</style>
